const STORAGE_KEY = 'bishoku_favorites';

declare const bishokuAjax: { url: string; nonce: string };

function getFavorites(): string[] {
  try {
    return JSON.parse(localStorage.getItem(STORAGE_KEY) ?? '[]');
  } catch {
    return [];
  }
}

function setFavorites(slugs: string[]): void {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(slugs));
}

function isFavorite(slug: string): boolean {
  return getFavorites().includes(slug);
}

function toggleFavorite(slug: string): boolean {
  const favs = getFavorites();
  const idx = favs.indexOf(slug);
  if (idx === -1) {
    setFavorites([...favs, slug]);
    return true;
  }
  setFavorites(favs.filter(s => s !== slug));
  return false;
}

function applyButtonState(btn: HTMLElement, active: boolean): void {
  btn.textContent = active ? 'お気に入りを解除' : 'お気に入りに追加';
  btn.classList.toggle('is-active', active);
}

function initSingleFavorite(): void {
  document.querySelectorAll<HTMLElement>('.feature-favorite[data-slug]').forEach(container => {
    const slug = container.dataset.slug!;
    const btn = container.querySelector<HTMLElement>('a');
    if (!btn) return;

    applyButtonState(btn, isFavorite(slug));

    btn.addEventListener('click', () => {
      const added = toggleFavorite(slug);
      // 同一ページに複数ボタンがある場合も同期
      document.querySelectorAll<HTMLElement>(`.feature-favorite[data-slug="${CSS.escape(slug)}"] a`).forEach(b => {
        applyButtonState(b, added);
      });
    });
  });
}

function loadFavoriteList(container: HTMLElement, page: number): void {
  if (typeof bishokuAjax === 'undefined') return;

  const slugs = getFavorites();

  if (slugs.length === 0) {
    container.innerHTML = '<p class="no-favorites">お気に入りに追加された記事はありません</p>';
    return;
  }

  container.innerHTML = '<p class="loading">読み込み中…</p>';

  const form = new FormData();
  form.append('action', 'bishoku_favorites_list');
  form.append('nonce', bishokuAjax.nonce);
  form.append('paged', String(page));
  slugs.forEach(s => form.append('slugs[]', s));

  fetch(bishokuAjax.url, { method: 'POST', body: form })
    .then(r => r.json())
    .then(({ success, data }) => {
      if (!success || !data.html) {
        container.innerHTML = '<p class="no-favorites">お気に入りに追加された特集記事はありません。</p>';
        return;
      }
      container.innerHTML = data.html + (data.pagination ?? '');
    })
    .catch(() => {
      container.innerHTML = '<p class="no-favorites">読み込みに失敗しました。</p>';
    });
}

function initFavoriteList(): void {
  const container = document.querySelector<HTMLElement>('.favorite-list');
  if (!container) return;

  loadFavoriteList(container, 1);

  container.addEventListener('click', e => {
    const target = e.target as HTMLElement;

    const delBtn = target.closest<HTMLElement>('.fav-button a');
    if (delBtn) {
      const slug = delBtn.closest<HTMLElement>('[data-slug]')?.dataset.slug;
      if (slug) {
        toggleFavorite(slug);
        loadFavoriteList(container, 1);
      }
      return;
    }

    const pageLink = target.closest<HTMLElement>('a.page-numbers[data-page]');
    if (pageLink) {
      e.preventDefault();
      loadFavoriteList(container, parseInt(pageLink.dataset.page!, 10));
    }
  });
}

export function initFeatureFavorite(): void {
  initSingleFavorite();
  initFavoriteList();
}
